'use client'

import { RefObject } from 'react'

import { Card } from '@/entities/contract'
import { useDialog } from '@/shared/lib'
import { AlertDialog, SegmentedControl } from '@/shared/ui'

import { AccountPayment, Props as AccountPaymentProps } from './account'
import { CardPayment, Props as CardPaymentProps } from './card'
import { PaymentMethod, usePaymentMethod } from '../../model/payment'

const LIMIT_OF_PAY_FEE_WITH_CARD = 10000000

const DIALOG = 'PAYMENT_SUGGESTION'

export type Props = AccountPaymentProps &
  CardPaymentProps & {
    ref: RefObject<HTMLDivElement | null>
  }

export const Payment = ({
  payDeadlineTime,
  vaBankName,
  vaAccountHolder,
  vaAccount,
  roomName,
  startDate,
  endDate,
  finalPayFee,
  ref,
}: Props) => {
  const canPayWithVirtualAccountOnly = finalPayFee >= LIMIT_OF_PAY_FEE_WITH_CARD

  const { paymentMethod, isSelected, updatePaymentMethod } = usePaymentMethod()

  const { isOpen, open, close } = useDialog()

  const handlePaymentMethodChange = (value: string) => {
    if (canPayWithVirtualAccountOnly && value === PaymentMethod.CARD) {
      open(DIALOG)

      return
    }

    updatePaymentMethod(value)
  }

  const handleDialogClose = () => {
    close(DIALOG)
  }

  return (
    <Card.Root spacing="large" ref={ref}>
      <Card.Item>
        <Card.ItemTitle>결제하기</Card.ItemTitle>
        <Card.ItemContent className="space-y-6">
          <SegmentedControl.Root
            size="medium"
            type="single"
            value={paymentMethod}
            onValueChange={handlePaymentMethodChange}
          >
            <SegmentedControl.Item value={PaymentMethod.ACCOUNT}>
              계좌이체
            </SegmentedControl.Item>
            <SegmentedControl.Item value={PaymentMethod.CARD}>
              카드결제
            </SegmentedControl.Item>
          </SegmentedControl.Root>

          {isSelected(PaymentMethod.ACCOUNT) && (
            <AccountPayment
              payDeadlineTime={payDeadlineTime}
              vaBankName={vaBankName}
              vaAccountHolder={vaAccountHolder}
              vaAccount={vaAccount}
              finalPayFee={finalPayFee}
            />
          )}

          {isSelected(PaymentMethod.CARD) && (
            <CardPayment
              payDeadlineTime={payDeadlineTime}
              finalPayFee={finalPayFee}
              roomName={roomName}
              startDate={startDate}
              endDate={endDate}
            />
          )}

          <AlertDialog
            isOpen={isOpen(DIALOG)}
            onOpenChange={handleDialogClose}
            title="카드결제 안내드립니다"
            content={`카드결제는 1,000만 원 미만의 금액만 가능합니다.\n계좌이체를 통해 결제해 주시기 바랍니다.`}
          />
        </Card.ItemContent>
      </Card.Item>
    </Card.Root>
  )
}
